import { useMutation, useQueryClient } from '@tanstack/react-query'

import { usersApi } from '../api/usersApi'
import { usersQueries } from '../api/usersQueries'
import type { UpdateUserRequest } from '../types/users.types'

export const useUpdateUserMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: UpdateUserRequest }) =>
      usersApi.updateUser(id, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: usersQueries.lists() }),
  })
}
